import { InjectionToken } from '@angular/core';
import type { Analytics as FbAnalytics } from 'firebase/analytics';

export type Analytics = FbAnalytics;
export const Analytics = new InjectionToken<FbAnalytics>('@fido/firebase.analytics');
